import { CssBaseline, ThemeProvider } from '@mui/material'
import { theme } from 'common/theme'
import { YandexMapProvider } from 'feature/YandexMap/YandexMapProvider'
import 'normalize.css'
import './index.scss'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { store } from 'store'

import App from './App'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
  <Provider store={store}>
    <YandexMapProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <App />
      </ThemeProvider>
    </YandexMapProvider>
  </Provider>,
)
